import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSysDirectory as _getSysDirectory } from '@data/user';
import directoryDC0033 from '@/assets/json/directoryDC0033';
import { schoolInfo, saveSchoolInfo as _saveSchoolInfo, getDC0033Json } from '@data/other';
export default {
  name: 'school-info',
  data: function data() {
    var paramsO = {
      type: '',
      // 学校办学类型,
      // 左侧------------------开始
      systme: '学制',
      //
      locationType: '地理位置',
      //
      provinceId: '该项',
      // 省ID
      cityId: '该项',
      // 市ID
      countyId: '该项',
      // 县ID
      address: '详细地址',
      // 学校地址-详细地址
      description: '描述',
      // 学校描述
      schoolCode: '学校代码',
      // 学校代码
      englishName: '学校英文名称',
      // 学校英文名称
      postalCode: '邮政编码',
      // 邮政编码
      areaCode: '行政区域码',
      // 行政区域码
      // 左侧------------------结束
      // 右侧------------------开始
      schoolYears: '建校年月',
      // 建校年月 --展示年和月
      decorationDay: '校庆日',
      // 校庆日
      legalRepresentativeNumber: '法定代表人号',
      // 法定代表人号
      legalPersonCertificateNo: '法人证书号',
      // 法人证书号
      principalCode: '校长工号',
      // 校长工号
      principalName: '校长姓名',
      // 校长姓名
      partyCommitteeLeaderNumber: '党委负责人号',
      // 党委负责人号
      organization: '组织机构',
      // 组织机构
      phone: '联系电话',
      // 联系电话
      fax: '传真电话',
      // 传真电话
      email: '电子邮箱',
      // 电子邮箱
      homePage: '主页地址',
      // 主页地址
      historicalEvolution: '历史沿革',
      // 历史沿革
      areaType: '所在地城乡类型',
      // 所在地城乡类型
      localEconomic: '所在地经济属性',
      // 所在地经济属性
      nationalProperty: '所在地民族属性',
      // 所在地民族属性
      mainTeachingLanguage: '主教学语言码',
      // 主教学语言码
      auxiliaryLanguage: '辅教学语言码',
      // 辅教学语言码
      admissionsRadius: '招生半径',
      // 招生半径
      // 右侧------------------结束
      system: '学制'
    }; // 设定单独的验证事件

    var checkFormItem = function checkFormItem(rule, value, callback) {
      var fieldStr = paramsO[rule.field]; // 如果数据不存在，或者清除日期数据未初始画时，数据重置。

      if (value === null || value === undefined) {
        value = '';
      } // let regExp = /select|update|delete|truncate|join|union|exec|insert|drop|count|script|src|alert|window|document|location|>|<|%/i;
      // let chartLength = (value+'').replace(/[^\x00-\xff]/g, '**').length;


      if (rule.required != null && rule.field === 'name') {
        // 验证非空
        callback();
      } else if (rule.required != null && value !== 0 && (value == null || value == '')) {
        // 验证非空
        callback(new Error(fieldStr + '不能为空！'));
      } else if (rule.field === 'principalName' && value.length > 50) {
        callback(new Error('最多只能输入50个字！'));
      } else if ((rule.field === 'description' || rule.field === 'homePage') && value.length > 200) {
        callback(new Error('最多只能输入200个字！'));
      } else if (value.length > 40 && rule.field !== 'address' && rule.field !== 'description' && rule.field !== 'homePage' & rule.field !== 'principalName') {
        // 验证非空
        callback(new Error('最多只能输入40个字！'));
      } else {
        callback();
      }
    };

    return {
      fullscreenLoading: false,
      showBaseForm: {
        orgParentName: '',
        type: '',
        name: '',
        system: ''
      },
      // 学校基本信息反显字段
      showBaseFormRules: {
        name: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }],
        type: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }],
        // 左侧------------------验证开始
        system: [{
          required: true,
          validator: checkFormItem,
          trigger: 'blur'
        }]
      },
      // 学校基本信息反显验证，方便展示*
      // 是否开启loading数据加载状态
      getLoadingShow: true,
      isShow: true,
      edit: 'add',
      // 字典表项
      directoryData: '',
      cityOptions: [],
      countyOptions: [],
      // 获取已经维护的学校信息
      showForm: {
        // 左侧------------------开始
        province: '',
        // 省
        provinceId: '',
        // 省ID
        city: '',
        //市
        cityId: '',
        // 市ID
        county: '',
        // 县
        countyId: '',
        // 县ID
        address: '',
        // 学校地址-详细地址
        description: '',
        // 学校描述
        schoolCode: '',
        // 学校代码
        englishName: '',
        // 学校英文名称
        postalCode: '',
        // 邮政编码
        areaCode: '',
        // 行政区域码
        schoolYears: '',
        // 建校年月 --展示年和月
        decorationDay: '',
        // 校庆日
        legalRepresentativeNumber: '',
        // 法定代表人号
        legalPersonCertificateNo: '',
        // 法人证书号
        principalCode: '',
        // 校长工号
        // 右侧------------------开始
        principalName: '',
        // 校长姓名
        partyCommitteeLeaderNumber: '',
        // 党委负责人号
        organization: '',
        // 组织机构
        phone: '',
        // 联系电话
        fax: '',
        // 传真电话
        email: '',
        // 电子邮箱
        homePage: '',
        // 主页地址
        historicalEvolution: '',
        // 历史沿革
        areaType: '',
        // 所在地城乡类型
        localEconomic: '',
        // 所在地经济属性
        nationalProperty: '',
        // 所在地民族属性
        mainTeachingLanguage: '',
        // 主教学语言码
        auxiliaryLanguage: '',
        // 辅教学语言码
        admissionsRadius: '' // 招生半径

      },
      // 新增 or 保存的学校信息
      form: {
        // 左侧------------------开始
        province: '',
        // 省
        provinceId: '',
        // 省ID
        city: '',
        //市
        cityId: '',
        // 市ID
        county: '',
        // 县
        countyId: '',
        // 县ID
        address: '',
        // 学校地址-详细地址
        description: '',
        // 学校描述
        schoolCode: '',
        // 学校代码
        englishName: '',
        // 学校英文名称
        postalCode: '',
        // 邮政编码
        areaCode: '',
        // 行政区域码
        schoolYears: '',
        // 建校年月 --展示年和月
        decorationDay: '',
        // 校庆日
        legalRepresentativeNumber: '',
        // 法定代表人号
        legalPersonCertificateNo: '',
        // 法人证书号
        principalCode: '',
        // 校长工号
        // 右侧------------------开始
        principalName: '',
        // 校长姓名
        partyCommitteeLeaderNumber: '',
        // 党委负责人号
        organization: '',
        // 组织机构
        phone: '',
        // 联系电话
        fax: '',
        // 传真电话
        email: '',
        // 电子邮箱
        homePage: '',
        // 主页地址
        historicalEvolution: '',
        // 历史沿革
        areaType: '',
        // 所在地城乡类型
        localEconomic: '',
        // 所在地经济属性
        nationalProperty: '',
        // 所在地民族属性
        mainTeachingLanguage: '',
        // 主教学语言码
        auxiliaryLanguage: '',
        // 辅教学语言码
        admissionsRadius: '' // 招生半径

      },
      // 新增 or 保存的学校信息验证规则
      formRules: {
        // 左侧------------------验证开始
        provinceId: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        cityId: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        countyId: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        address: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        description: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        schoolCode: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        englishName: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        postalCode: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        areaCode: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        schoolYears: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        decorationDay: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        legalRepresentativeNumber: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        legalPersonCertificateNo: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        principalCode: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        // 右侧------------------验证开始
        principalName: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        partyCommitteeLeaderNumber: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        organization: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        phone: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        fax: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        email: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        homePage: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        historicalEvolution: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        areaType: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        localEconomic: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        nationalProperty: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        mainTeachingLanguage: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        auxiliaryLanguage: [{
          validator: checkFormItem,
          trigger: 'blur'
        }],
        admissionsRadius: [{
          validator: checkFormItem,
          trigger: 'blur'
        }] // 右侧------------------验证结束

      },
      provinceIndex: '',
      cityIndex: '',
      countyIndex: ''
    };
  },
  beforeCreate: function beforeCreate() {// 组件实例刚被创建，组件属性计算之前，如data属性等
  },
  created: function created() {// 组件实例创建完成，属性已绑定，但Dom还未生成，$el属性还不存在
  },
  beforeMount: function beforeMount() {// 模板编译/挂载之前
  },
  mounted: function mounted() {
    this.getLoadingShow = true; // 模板编译/挂载之后（不保证组件已经在document中）

    this.initSchoolInfo();
  },
  beforeUpdate: function beforeUpdate() {// 组件更新之前
  },
  updated: function updated() {// 组件更新之后
  },
  activated: function activated() {// 组件被激活时调用
  },
  deactivated: function deactivated() {// 组件被移除时调用
  },
  beforeDestroy: function beforeDestroy() {// 组件销毁前调用
  },
  destroyed: function destroyed() {// 组件销毁后调用
  },
  methods: {
    /**
     * @function initSchoolInfo 初始化学校信息
     **/
    initSchoolInfo: function initSchoolInfo() {
      this.getSysDirectory(); // 获取系统字典表
    },
    convertText: function convertText(options, indexOrValue, type) {
      if (type === 1) {
        // 如果是type === 1，表示的是存储的是下标，需要通过index取下标对应的itemName
        if (options === null || options === undefined || options === '') {
          return '';
        } else if (indexOrValue === '') {
          return '';
        } else if (options[indexOrValue].itemName !== undefined && options[indexOrValue].itemName !== null && options[indexOrValue].itemName !== '') {
          return options[indexOrValue].itemName;
        } else {
          return '';
        }
      } else if (type === 2) {
        // 如果type === 2，表示的是存储的是value，需要通过value反显控制
        if (options === null || options === undefined || options === '') {
          return '';
        } else {
          var resultList = options.filter(function (okm) {
            return okm.value === indexOrValue;
          });

          if (resultList === null || resultList === undefined || resultList === '') {
            return '';
          } else if (resultList[0] === null || resultList[0] === undefined || resultList[0] === '') {
            return '';
          } else if (resultList[0].itemName !== undefined && resultList[0].itemName !== null && resultList[0].itemName !== '') {
            return resultList[0].itemName;
          } else {
            return '';
          }
        }
      }
    },
    getSysDirectory: function getSysDirectory() {
      var self = this; // 查'学制', '地理位置', '所在经济属性', '所在地民族属性', '教学语言码', '省市区'

      _getSysDirectory({
        codes: 'DC0001,DC0002,DC0003,DC0004,DC0005,DC0006,DC0007'
      }).then(function (res) {
        self.directoryData = res;
        self.directoryData.DC0033 = directoryDC0033.data.DC0033;
        self.getSchoolInfo();
      }).catch(function () {});
    },

    /*function getSchoolInfo 拿取学校自维护的基本信息*/
    getSchoolInfo: function getSchoolInfo() {
      var _this = this;

      var self = this;
      this.fullscreenLoading = true;
      schoolInfo().then(function (res) {
        res.system = res.schoolBase.systme || '';
        self.showBaseForm = res;
        self.initQueryInfo(self, res);
        self.setAllAdressInfo(self);
        _this.fullscreenLoading = false;
      }).catch(function () {
        _this.fullscreenLoading = false;
      });
    },
    setAllAdressInfo: function setAllAdressInfo(self) {
      // 通过provinceId知道其 provinceIndex
      if (self.directoryData !== null && self.directoryData !== undefined && self.form.provinceId !== '') {
        var compareProvinceId = self.form['provinceId'];
        var compareCityId = self.form['cityId'];
        var compareCountyId = self.form['countyId'];

        for (var i = 0; i < self.directoryData.DC0033.length; i++) {
          var thatOptions = self.directoryData.DC0033[i];

          if (thatOptions.id === parseInt(compareProvinceId)) {
            self.provinceIndex = i;

            for (var j = 0; j < thatOptions.subList.length; j++) {
              var thatCoptions = thatOptions.subList[j];

              if (thatCoptions.id === parseInt(compareCityId)) {
                self.cityIndex = j;

                for (var k = 0; k < thatCoptions.subList.length; k++) {
                  var thatNoptions = thatCoptions.subList[k];

                  if (thatNoptions.id === parseInt(compareCountyId)) {
                    self.countyIndex = k;
                  }
                }
              }
            }
          }
        }
      }
    },
    initQueryInfo: function initQueryInfo(self, res) {
      // 如果type === 1，表示是重置按钮点击触发拷贝；如果不为空，直接拷贝对象。
      var schoolExtend = res.schoolExtend || {};
      var schoolBase = res.schoolBase || {}; // 处理数据

      for (var key in schoolBase) {
        self.form[key] = self.deepClone(schoolBase[key]);
      }

      for (var _key in schoolExtend) {
        // 校庆日、建校年月特殊处理
        if (_key === 'schoolYears' || _key === 'decorationDay') {
          self.form[_key] = self.deepClone(schoolExtend[_key].substr(0, 10) || '');
        }

        self.form[_key] = self.deepClone(schoolExtend[_key]);
      }
    },
    getVoType: function getVoType(obj) {
      var toString = Object.prototype.toString;
      var map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      return map[toString.call(obj)];
    },
    deepClone: function deepClone(data) {
      var self = this;
      var voType = self.getVoType(data),
          tempArray,
          i,
          dataLength;

      if (voType === 'array') {
        tempArray = [];
      } else if (voType === 'object') {
        tempArray = {};
      } else {
        return data;
      }

      if (voType === 'array') {
        for (i = 0, dataLength = data.length; i < dataLength; i++) {
          tempArray.push(self.deepClone(data[i]));
        }

        return tempArray;
      } else if (voType === 'object') {
        for (i in data) {
          tempArray[i] = self.deepClone(data[i]);
        }

        return tempArray;
      }
    },
    showAddForm: function showAddForm() {
      this.isShow = false;
      this.edit = 'edit';
    },
    resetForm: function resetForm() {
      var oldInfo = Object.assign({}, this.showBaseForm);
      var oldForm = Object.assign({}, this.form);
      var oldInfoAndForm = Object.assign(oldInfo, oldForm); //        this.$refs['form'].resetFields();

      this.initQueryInfo(this, oldInfoAndForm, 1);
      this.isShow = true;
      this.edit = 'edit';
    },

    /*function saveSchoolInfo 保存学校信息*/
    saveSchoolInfo: function saveSchoolInfo() {
      var self = this; // 第一步： 检查form表单是否验证通过

      this.$refs.form.validate(function (valid) {
        if (valid) {
          delete self.form.type;
          var params = self.form;
          params.systme = self.showBaseForm.system; // 第二步： 发送请求

          _saveSchoolInfo(params).then(function () {
            self.isShow = true;
          }).catch(function () {});
        }
      });
    }
  },
  computed: {},
  watch: {
    provinceIndex: function provinceIndex() {
      // 当省选择后，改变市内容，清空县内容
      var provinceTemp = this.directoryData.DC0033[this.provinceIndex] || {};
      this.cityOptions = provinceTemp.subList || [];
      this.form.provinceId = provinceTemp.id || '';
      this.form.province = provinceTemp.itemName || '';

      if (!parseInt(this.form.provinceId) === provinceTemp.id) {
        this.countyOptions = [];
        this.cityIndex = '';
        this.countyIndex = '';
      }
    },
    cityIndex: function cityIndex() {
      // 当市选择后，改变县内容
      var cityTemp = this.cityOptions[this.cityIndex] || {};
      this.countyOptions = cityTemp.subList || [];
      this.form.cityId = cityTemp.id || '';
      this.form.city = cityTemp.itemName || '';

      if (!(parseInt(this.form.cityId) === cityTemp.id)) {
        this.countyIndex = '';
      }
    },
    countyIndex: function countyIndex() {
      // 当市选择后，改变县内容
      var countyTemp = this.countyOptions[this.countyIndex] || {};
      this.form.countyId = countyTemp.id || '';
      this.form.county = countyTemp.itemName || '';
    }
  }
};